import { useRef, useState, createContext } from 'react';

export const SeoContext = createContext(null);

export function useSeoContext() {
    const [context, setContext] = useState({
        pathname: useRef(null).current,
        location: useRef(null).current,
        metas: undefined,
        ogmetas: undefined,
        jsonld:undefined,
        label:undefined,
        htmlHref: null,
        htmlContent: null,
        showHtmlContainer: false,
        refreshMetas: true,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        setPathname: function(pathname,location){
            this.pathname = pathname;
            this.location = location;
        },
        refreshPathname: function(pathname,location,refreshMetas=true){
            this.update ({pathname,location,refreshMetas});
        },
        setRefreshMetas: function(refreshMetas){
            this.update ({refreshMetas});
        },
        setMetas: function(metas){
            this.update ({metas});
        },
        setOpenGraphMetas: function(ogmetas){
            this.update ({ogmetas});
        },
        setJsonLd: function(jsonld){
            this.update ({jsonld});
        },
        setLabel: function(label){
            this.update ({label});
        },
        setHtmlHref: function(htmlHref){
            this.update ({htmlHref});
        },
        setHtmlContent: function(htmlContent){
            this.update ({htmlContent});
        },
        setShowHtmlContainer: function(showHtmlContainer){
            this.update ({showHtmlContainer});
        }
    });

    return [context, setContext];
}

